export const centsToDollar = (value: number) => value / 100 
export const dollarToCents = (value: number) => value * 100 